import React, { Component, Fragment } from "react";
import {
  Button,
  Grid,
  Container,
  Header,
  Divider,
  Item,
  Segment
} from "semantic-ui-react";

import * as LINKS from "../assets/Links";
import * as CONSTANTS from "../assets/Constants";
import ProjectCard from "../components/ProjectCard";

let SAI_TEJA_BLOG = "detecting-harmless-people-in-war-zone-1e54be878bdc";
let YADHURAY_BLOG = "hand-gesture-control-bot-1c4bd6f56f4d";

class Projects extends Component {
  state = { projects: [] };

  componentWillMount() {
    let projectsToBeRendered = [];
    fetch(
      LINKS.SERVER_BASE_URL +
        LINKS.SERVER_ROUTES.getRandomProjects +
        CONSTANTS.randomProjectsCountLanding
    )
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        console.log(data["random_ids"]);
        data["projects"].forEach(function(project) {
          projectsToBeRendered.push(
            <ProjectCard key={project.id} data={project} />
          );
        });
        this.setState({
          projects: projectsToBeRendered
        });
      })
      .catch(error => {
        console.log(error);
      });
  }
  renderProjectsOrBlogLinks = () => {
    if (this.state.projects.length === 3) {
      return (
        <Fragment>
          <Header as="h4" style={{ fontSize: "2em" }} textAlign="center">
            Some of our many Projects
          </Header>
          {/*  */}
          <Item.Group divided>{this.state.projects}</Item.Group>
          <Grid style={{ marginTop: "1em" }}>
            <Grid.Column textAlign="center">
              <Button as="a" href="#/projects" size="large">
                Explore more
              </Button>
            </Grid.Column>
          </Grid>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Divider
            as="h4"
            className="header"
            horizontal
            style={{ margin: "3em 0em", textTransform: "uppercase" }}
          >
            <p>One of our many Projects</p>
          </Divider>
          <Header as="h4" style={{ fontSize: "2em" }}>
            Detecting Harmless people in War Zone
          </Header>
          <p style={{ fontSize: "1.2em" }}>
            This project is focused on saving children(harmless) from harmful
            places in war zone using deep learning(Convolution Neural Network)
            and computer vision techniques.
          </p>
          <Button
            as="a"
            href={LINKS.MEDIUM_BLOGS_LINK + SAI_TEJA_BLOG}
            size="large"
          >
            Read More
          </Button>
          <Divider
            as="h4"
            className="header"
            horizontal
            style={{ margin: "3em 0em", textTransform: "uppercase" }}
          >
            <p>One of our many Projects</p>
          </Divider>
          <Header as="h4" style={{ fontSize: "2em" }}>
            Hand Gesture control bot
          </Header>
          <p style={{ fontSize: "1.2em" }}>
            The basic idea behind this project is to control a bot using your
            hand gesture.
          </p>
          <Button
            as="a"
            href={LINKS.MEDIUM_BLOGS_LINK + YADHURAY_BLOG}
            size="large"
          >
            Read More
          </Button>
        </Fragment>
      );
    }
  };

  render() {
    return (
      <Segment style={{ padding: "3em 0em", marginBottom: "3em" }} vertical>
        <Container text>
          {this.renderProjectsOrBlogLinks()}
        </Container>
      </Segment>
    );
  }
}

export default Projects;
